//authcontext.js

import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import apiUrl from './config';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true); // Gérer le loading pour les vérifications

  useEffect(() => {
    const token = localStorage.getItem('token');
    
    if (token) {
      validateToken(token);
    } else {
      setLoading(false);
      setIsAuthenticated(false);
    }
  }, []);

  // Fonction pour vérifier la validité du token
  const validateToken = async (token) => {
    try {
      
      const response = await axios.get(`${apiUrl}/check-session`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,  // Assurez-vous que les cookies sont envoyés
      });
  
      // Si le token est valide, authentifier l'utilisateur
      
      setIsAuthenticated(true);
      setRole(response.data.role);
    } catch (error) {
      console.error('Token is invalid or expired');
      localStorage.removeItem('token');  // Supprimer le token expiré
      setIsAuthenticated(false);
    } finally {
      setLoading(false);  // Fin du chargement
    }
  };
  
  // Connexion utilisateur
  const login = (userRole, token) => {
    localStorage.setItem('token', token);  // Stocker le token dans le localStorage
    setIsAuthenticated(true);
    setRole(userRole);
  };

  // Déconnexion utilisateur
  const logout = async () => {
    try {
      await axios.post(`${apiUrl}/logout`, {}, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      localStorage.removeItem('token');
      setIsAuthenticated(false);
      setRole(null);
    } catch (error) {
      console.error('Logout error:', error.response ? error.response.data : error.message);
    }
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, role, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
